import { render, staticRenderFns } from "./HeatFooter.vue?vue&type=template&id=b91d8e22&scoped=true&"
import script from "./HeatFooter.vue?vue&type=script&lang=js&"
export * from "./HeatFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b91d8e22",
  null
  
)

export default component.exports